import { call, put, takeLatest, takeEvery, cancel } from 'redux-saga/effects';
import moment from 'moment';
import { initialize } from 'redux-form';
import fileDownload from 'react-file-download';

import {
  REPORTS_SALES_PAGE_REQUEST,
  REPORTS_SALES_SUMMARY_REQUEST,
  REPORTS_SALES_TYPE_PAGE_REQUEST,
  REPORTS_SALES_TYPE_REQUEST,
  REPORTS_GROSS_PROFIT_PAGE_REQUEST,
  REPORTS_GROSS_PROFIT_REQUEST,
  REPORTS_PAYMENT_METHODS_PAGE_REQUEST,
  REPORTS_PAYMENT_METHODS_REQUEST,
  REPORTS_ITEM_SALES_PAGE_REQUEST,
  REPORTS_ITEM_SALES_REQUEST,
  REPORTS_CATEGORY_SALES_PAGE_REQUEST,
  REPORTS_CATEGORY_SALES_REQUEST,
  REPORTS_BRAND_SALES_PAGE_REQUEST,
  REPORTS_MODIFIER_SALES_PAGE_REQUEST,
  REPORTS_MODIFIER_SALES_REQUEST,
  REPORTS_DISCOUNTS_REQUEST,
  REPORTS_TAXES_PAGE_REQUEST,
  REPORTS_TAXES_REQUEST,
  REPORTS_GRATUITY_PAGE_REQUEST,
  REPORTS_GRATUITY_REQUEST,
  REPORTS_COLLECTEDBY_PAGE_REQUEST,
  REPORTS_COLLECTEDBY_REQUEST,
  REPORTS_SERVEDBY_PAGE_REQUEST,
  REPORTS_SERVEDBY_REQUEST,
  REPORTS_SALES_SUMMARY_CHANGE_DATE,
  REPORTS_SALES_TYPE_CHANGE_DATE,
  REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE,
  REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE,
  REPORTS_SALES_ITEM_SALES_CHANGE_DATE,
  REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE,
  REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE,
  REPORTS_SALES_DISCOUNTS_CHANGE_DATE,
  REPORTS_SALES_TAXES_CHANGE_DATE,
  REPORTS_SALES_GRATUITY_CHANGE_DATE,
  REPORTS_SALES_COLLECTEDBY_CHANGE_DATE,
  REPORTS_SALES_SERVEDBY_CHANGE_DATE,
  REPORTS_SALES_SUMMARY_CHANGE_OUTLET,
  REPORTS_SALES_TYPE_CHANGE_OUTLET,
  REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET,
  REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET,
  REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET,
  REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET,
  REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET,
  REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET,
  REPORTS_SALES_TAXES_CHANGE_OUTLET,
  REPORTS_SALES_GRATUITY_CHANGE_OUTLET,
  REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET,
  REPORTS_SALES_SERVEDBY_CHANGE_OUTLET,
  REPORTS_SALES_EXPORT_SUMMARY,
  REPORTS_SALES_EXPORT_SALES_TYPE,
  REPORTS_SALES_EXPORT_GROSS_PROFIT,
  REPORTS_SALES_EXPORT_PAYMENT_METHODS,
  REPORTS_SALES_EXPORT_HOURLY_ITEM,
  REPORTS_SALES_QUANTITY_SUMMARY,
  REPORTS_SALES_EXPORT_ITEM_SALES,
  REPORTS_SALES_EXPORT_CATEGORY_SALES,
  REPORTS_SALES_EXPORT_MODIFIER_SALES,
  REPORTS_SALES_EXPORT_DISCOUNTS,
  REPORTS_SALES_EXPORT_TAXES,
  REPORTS_SALES_EXPORT_GRATUITY,
  REPORTS_SALES_EXPORT_COLECTEDBY,
  REPORTS_SALES_EXPORT_SERVEDBY,
  REPORT_SALES_GENERAL_EXPORT,
} from '../../actions/reports/sales/constants';
import { LOGOUT } from '../../actions/constants';
import {
  salesSummaryRequest,
  setSalesSummary,
  salesTypeRequest,
  setSalesTypes,
  grossProfitRequest,
  setGrossProfit,
  paymentMethodsRequest,
  setPaymentMethods,
  itemSalesRequest,
  setItemSales,
  resetItemSales,
  categorySalesRequest,
  setCategorySales,
  resetCategorySales,
  setBrandSales,
  resetBrandSales,
  modifierSalesRequest,
  setModifierSales,
  discountsRequest,
  setDiscounts,
  taxesRequest,
  setTaxes,
  gratuityRequest,
  setGratuity,
  collectedByRequest,
  setCollectedBy,
  servedByRequest,
  setServedBy,
  setOutlets,
  reportsShowLoadingSpinner,
  discountsPageRequest,
} from '../../actions/reports/sales';
import {
  exportQuantitySummaryReport,
  exportReportApi,
} from '../../api/openApi';
import { setCurrentOutlet } from '../../actions/outlet';
import * as actNotif from '../../actions/notifications';
import * as actActionBar from '../../actions/actionBar';
import * as action from '../../actions';

import * as apiOutlets from '../../api/outlets';
import * as apiReport from '../../api/sales';
import {
  getFormattedEndDate,
  DEFAULT_START_HOUR,
  DEFAULT_END_HOUR,
} from '../../utils/hourFilter';
import {
  getSelectedOutletIdFromLocalStorage,
  setSelectedOutletIdToLocalStorage,
} from '../../utils/selectedOutletId';
import { assertErrorHasMessage } from '../../utils/assert';
import * as clevertapReportsSummary from '../../clevertap/reports/summary';
import * as clevertapReportsSalesType from '../../clevertap/reports/salesType';
import * as clevertapReportsPaymentMethods from '../../clevertap/reports/paymentMethods';
import * as clevertapReportsCategorySales from '../../clevertap/reports/categorySales';
import * as clevertapReportsModifierSales from '../../clevertap/reports/modifierSales';
import * as clevertapReportsTaxes from '../../clevertap/reports/taxes';
import * as clevertapReportsDiscounts from '../../clevertap/reports/discounts';
import * as clevertapReportsGratuity from '../../clevertap/reports/gratuity';
import * as clevertapReportsCollected from '../../clevertap/reports/collected';
import * as clevertapReportsServed from '../../clevertap/reports/served';
import * as clevertapReportsGrossProfit from '../../clevertap/reports/grossProfit';
import {
  postSalesSummary,
  getSalesType,
  getPaymentMethods,
  postItemSales,
  postItemBundleSales,
  postCategorySales,
  getModifierSales,
  getDiscounts,
  getTaxes,
  getGratuities,
  getStaffs,
  getServers,
  postGrossProfit,
  postBrandSales,
} from '../api/sales';
import {
  getFilteredDateAsMoment,
  getFilteredDate,
} from '../api/get-filtered-date';

const API_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

function* fillForm(outletIds, startDate, endDate) {
  // only all day that will give 23:59:59. hour filter is hour based
  const allDay = moment(endDate).format('HH:mm') === '23:59';
  const startHour = !allDay
    ? moment(startDate).format('HH:mm')
    : DEFAULT_START_HOUR;
  const endHour = !allDay ? moment(endDate).format('HH:mm') : DEFAULT_END_HOUR;

  yield put(
    initialize('search', {
      outlet: outletIds,
      date: { startDate, endDate, startHour, endHour, allDay },
    })
  );
}

function getErrorMessage(error) {
  if (error.code === 'ECONNABORTED') {
    return 'Oops! We failed to load your data. Please try again or use a smaller range of time.';
  }
  return error.message;
}

function* getQuery() {
  yield put(reportsShowLoadingSpinner(true));
  yield put(action.showProgressBar());
  // call date api
  const filteredDate = yield call(getFilteredDateAsMoment);
  const start = moment(filteredDate.startDate).format('YYYY-MM-DD HH:mm:ss');
  const end = moment(filteredDate.endDate).format('YYYY-MM-DD HH:mm:ss');

  // set outlets
  const resOutlets = yield call(apiOutlets.outlets);
  yield put(setOutlets(resOutlets.data));

  const outletIds = getSelectedOutletIdFromLocalStorage();

  // set actionbar state - used for connecting nav outlet and redux form value
  yield put(actActionBar.setOutlets(resOutlets.data));
  yield put(actActionBar.setSelectedOutletIds(outletIds));

  // set form state
  yield call(fillForm, outletIds, start, end);

  return {
    startDate: start,
    endDate: getFormattedEndDate(end),
    outletIds,
  };
}

export function* reportsSalesPageRequestFlow() {
  try {
    yield put(setSalesSummary([]));
    // set false by salessummary request saga
    yield put(reportsShowLoadingSpinner(true));

    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDateAsMoment);
    const start = moment(filteredDate.startDate).format('YYYY-MM-DD HH:mm:ss');
    const end = moment(filteredDate.endDate).format('YYYY-MM-DD HH:mm:ss');

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);

    const query = {
      startDate: start,
      endDate: getFormattedEndDate(end),
      outletIds,
    };

    yield put(salesSummaryRequest(query));
    clevertapReportsSummary.reportSummaryStart({
      outletIds,
      startDate: filteredDate.startDate,
      endDate: filteredDate.endDate,
    });
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getSalesSummaryFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate } = request.payload;
  const { endDate } = request.payload;
  const { outletIds } = request.payload;
  const salesSummary = yield call(
    postSalesSummary,
    { startDate, endDate },
    outletIds
  );

  if (salesSummary) {
    const objSalesSummary = {
      discounts: salesSummary.discount,
      gratuity: salesSummary.gratuity,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      gross_sales: salesSummary.grossSales,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      net_sales: salesSummary.netSales,
      refunds: salesSummary.refund,
      tax: salesSummary.tax,
      rounding: salesSummary.roundingAmount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      total_collected: salesSummary.totalCollected,
    };
    yield put(setSalesSummary(objSalesSummary));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* grossProfitPageRequestFlow() {
  try {
    yield put(setGrossProfit([]));
    // set false by salessummary request saga
    yield put(reportsShowLoadingSpinner(true));

    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDateAsMoment);
    const start = moment(filteredDate.startDate).format('YYYY-MM-DD HH:mm:ss');
    const end = moment(filteredDate.endDate).format('YYYY-MM-DD HH:mm:ss');

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);

    const query = {
      startDate: start,
      endDate: getFormattedEndDate(end),
      outletIds,
    };
    yield put(grossProfitRequest(query));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getGrossProfitFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate } = request.payload;
  const { endDate } = request.payload;
  const { outletIds } = request.payload;
  const grossProfit = yield call(
    postGrossProfit,
    { startDate, endDate },
    outletIds
  );
  if (grossProfit) {
    yield put(setGrossProfit(grossProfit));
    clevertapReportsGrossProfit.reportGrossProfitStart({ grossProfit });
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* paymentMethodsPageRequestFlow() {
  try {
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());

    // call date api
    const filteredDate = yield call(getFilteredDateAsMoment);
    const start = moment(filteredDate.startDate).format('YYYY-MM-DD HH:mm:ss');
    const end = moment(filteredDate.endDate).format('YYYY-MM-DD HH:mm:ss');

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);

    const query = {
      startDate: start,
      endDate: getFormattedEndDate(end),
      outletIds,
    };
    yield put(paymentMethodsRequest(query));
    clevertapReportsPaymentMethods.reportsPaymentMethodsStart({
      outletIds,
      startDate: start,
      endDate: end,
    });
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getPaymentMethodsFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate } = request.payload;
  const { endDate } = request.payload;
  const { outletIds } = request.payload;
  const paymentMethods = yield call(
    getPaymentMethods,
    { startDate, endDate },
    outletIds
  );

  if (paymentMethods) {
    yield put(setPaymentMethods(paymentMethods));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* itemSalesPageRequestFlow(request) {
  try {
    yield put(resetItemSales());
    // set false by itemsales request saga
    yield put(reportsShowLoadingSpinner(true));

    yield put(action.showProgressBar());
    const { type } = request.payload;
    // call date api
    const filteredDate = yield call(getFilteredDateAsMoment);
    const start = moment(filteredDate.startDate).format('YYYY-MM-DD HH:mm:ss');
    const end = moment(filteredDate.endDate).format('YYYY-MM-DD HH:mm:ss');

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);

    const query = {
      startDate: start,
      endDate: getFormattedEndDate(end),
      outletIds,
      type,
    };
    yield put(itemSalesRequest(query));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getItemSalesFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds, type } = request.payload;
  const apiMap = {
    inc: postItemSales,
    qty: postItemBundleSales,
  };
  const itemSales = yield call(apiMap[type], { startDate, endDate }, outletIds);

  if (itemSales) {
    yield put(setItemSales(itemSales));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* getItemSalesQuantityFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate } = request.payload;
  const { endDate } = request.payload;
  const { outletIds } = request.payload;
  const itemSales = yield call(
    postItemSales,
    { startDate, endDate },
    outletIds
  );

  if (itemSales) {
    yield put(setItemSales(itemSales));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* categorySalesPageRequestFlow(request) {
  try {
    const { callback } = request.payload || {};

    yield put(resetCategorySales());
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDateAsMoment);
    const start = moment(filteredDate.startDate).format('YYYY-MM-DD HH:mm:ss');
    const end = moment(filteredDate.endDate).format('YYYY-MM-DD HH:mm:ss');

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);

    const query = {
      startDate: start,
      endDate: getFormattedEndDate(end),
      outletIds,
    };
    yield put(categorySalesRequest(query));

    clevertapReportsCategorySales.reportsCategorySalesStart({
      outletIds,
      startDate: start,
      endDate: end,
    });

    callback?.({
      outletIds,
      startDate: start,
      endDate: end,
    });
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getCategorySalesFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate } = request.payload;
  const { endDate } = request.payload;
  const { outletIds } = request.payload;
  const categorySales = yield call(
    postCategorySales,
    { startDate, endDate },
    outletIds
  );

  if (categorySales) {
    yield put(setCategorySales(categorySales));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* brandSalesPageRequestFlow(request) {
  try {
    let query;
    const { startDate, endDate, outletIds } = request.payload || {};
    yield put(resetBrandSales());
    if (request.payload) {
      query = request.payload;
      setSelectedOutletIdToLocalStorage(outletIds);
      yield call(fillForm, outletIds, startDate, endDate);
    } else {
      query = yield call(getQuery);
    }
    yield call(getBrandSalesFlow, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getBrandSalesFlow(payload) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds } = payload;
  const brandSales = yield call(
    postBrandSales,
    { startDate, endDate },
    outletIds
  );

  if (brandSales) {
    yield put(setBrandSales(brandSales));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* modifierSalesPageRequestFlow() {
  try {
    yield put(setModifierSales([]));
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDate);
    const start = moment(filteredDate.start_date).format('YYYY-MM-DD HH:mm:ss');
    const end = moment(filteredDate.end_date).format('YYYY-MM-DD HH:mm:ss');

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);
    clevertapReportsModifierSales.reportsModifierSalesStart({
      outletIds,
      startDate: start,
      endDate: end,
    });
    yield put(
      modifierSalesRequest({
        startDate: start,
        endDate: getFormattedEndDate(end),
        outletIds,
      })
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getModifierSalesFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const {
    modifierSales,
    totalQuantity,
    totalGrossSales,
    totalDiscount,
    totalRefund,
    totalNetSales,
  } = yield call(getModifierSales, request.payload);

  if (modifierSales) {
    yield put(
      setModifierSales(
        modifierSales,
        totalQuantity,
        totalGrossSales,
        totalDiscount,
        totalRefund,
        totalNetSales
      )
    );
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* discountsPageRequestFlow(request) {
  try {
    const callback = request.payload;

    yield put(setDiscounts([]));
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDateAsMoment);
    const startDate = moment(filteredDate.startDate).format(API_DATE_FORMAT);
    const endDate = moment(filteredDate.endDate).format(API_DATE_FORMAT);

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, startDate, endDate);

    const query = {
      startDate,
      endDate: getFormattedEndDate(endDate),
      outletIds,
    };

    yield put(discountsRequest(query));

    clevertapReportsDiscounts.reportsDiscountStart({
      outletIds,
      startDate,
      endDate,
    });

    callback?.({
      outletIds,
      startDate,
      endDate,
    });
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getDiscountsFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds } = request.payload;
  const discounts = yield call(getDiscounts, { startDate, endDate, outletIds });

  if (discounts) {
    yield put(setDiscounts(discounts));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* taxesPageRequestFlow() {
  try {
    yield put(setTaxes([]));
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDate);
    const startDate = moment(filteredDate.start_date).format(API_DATE_FORMAT);
    const endDate = moment(filteredDate.end_date).format(API_DATE_FORMAT);

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds());

    // set form state
    yield call(fillForm, outletIds, startDate, endDate);
    clevertapReportsTaxes.reportsTaxStart({
      outletIds,
      startDate,
      endDate,
    });
    yield put(
      taxesRequest({
        startDate,
        endDate: getFormattedEndDate(endDate),
        outletIds,
      })
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getTaxesFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds } = request.payload;
  const taxes = yield call(getTaxes, { startDate, endDate, outletIds });

  if (taxes) {
    yield put(setTaxes(taxes));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* gratuityPageRequestFlow() {
  try {
    yield put(setGratuity([]));
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDate);
    const startDate = moment(filteredDate.start_date).format(API_DATE_FORMAT);
    const endDate = moment(filteredDate.end_date).format(API_DATE_FORMAT);

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, startDate, endDate);

    yield put(
      gratuityRequest({
        startDate,
        endDate: getFormattedEndDate(endDate),
        outletIds,
      })
    );
    clevertapReportsGratuity.reportsGratuityStart({
      outletIds,
      startDate,
      endDate,
    });
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getGratuitiesFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds } = request.payload;
  const gratuities = yield call(getGratuities, {
    startDate,
    endDate,
    outletIds,
  });

  if (gratuities) {
    yield put(setGratuity(gratuities));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* salesTypePageRequestFlow() {
  try {
    yield put(setSalesTypes([]));
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDate);
    const startDate = moment(filteredDate.start_date).format(
      'YYYY-MM-DD HH:mm:ss'
    );
    const endDate = moment(filteredDate.end_date).format('YYYY-MM-DD HH:mm:ss');

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, startDate, endDate);

    yield put(
      salesTypeRequest({
        startDate,
        endDate: getFormattedEndDate(endDate),
        outletIds,
      })
    );
    clevertapReportsSalesType.reportsSalesTypeStart({
      outletIds,
      startDate,
      endDate,
    });
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getSalesTypesFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds } = request.payload;
  const { salesTypes, totalAmount } = yield call(getSalesType, {
    startDate,
    endDate,
    outletIds,
  });
  if (salesTypes) {
    yield put(setSalesTypes(salesTypes, totalAmount));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* collectedByPageRequestFlow(request) {
  try {
    const { callback } = request.payload || {};
    yield put(setCollectedBy([]));
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDate);
    const start = moment(filteredDate.start_date).format(API_DATE_FORMAT);
    const end = moment(filteredDate.end_date).format(API_DATE_FORMAT);

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);

    yield put(
      collectedByRequest({
        startDate: start,
        endDate: getFormattedEndDate(end),
        outletIds,
      })
    );

    clevertapReportsCollected.reportCollectedStart({
      outletIds,
      startDate: start,
      endDate: end,
    });

    callback?.({
      outletIds,
      startDate: start,
      endDate: end,
    });
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getStaffsFlow(request) {
  const { startDate, endDate, outletIds } = request.payload;
  yield put(reportsShowLoadingSpinner(true));
  const staffs = yield call(getStaffs, { startDate, endDate, outletIds });

  if (staffs) {
    yield put(setCollectedBy(staffs));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* servedByPageRequestFlow() {
  try {
    yield put(setServedBy([]));
    yield put(reportsShowLoadingSpinner(true));
    yield put(action.showProgressBar());
    // call date api
    const filteredDate = yield call(getFilteredDate);
    const start = moment(filteredDate.start_date).format(API_DATE_FORMAT);
    const end = moment(filteredDate.end_date).format(API_DATE_FORMAT);

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets);
    yield put(setOutlets(resOutlets.data));
    const outletIds = getSelectedOutletIdFromLocalStorage();

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data));
    yield put(actActionBar.setSelectedOutletIds(outletIds));

    // set form state
    yield call(fillForm, outletIds, start, end);
    clevertapReportsServed.reportServedStart({
      outletIds,
      startDate: start,
      endDate: end,
    });
    yield put(
      servedByRequest({
        startDate: start,
        endDate: getFormattedEndDate(end),
        outletIds,
      })
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getServersFlow(request) {
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds } = request.payload;
  const servers = yield call(getServers, { startDate, endDate, outletIds });

  if (servers) {
    yield put(setServedBy(servers));
  }
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeDateSalesSummaryFlow(request) {
  // will be set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  const query = { startDate, endDate: getFormattedEndDate(endDate), outletIds };
  yield call(fillForm, outletIds, startDate, endDate);
  yield put(salesSummaryRequest(query));
}

export function* changeDateSalesTypeFlow(request) {
  yield put(setSalesTypes([]));
  // will be set false by sales type request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  yield put(
    salesTypeRequest({
      startDate,
      endDate: getFormattedEndDate(endDate),
      outletIds,
    })
  );
}

export function* changeDateGrossProfitFlow(request) {
  // will be set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  const query = { startDate, endDate: getFormattedEndDate(endDate), outletIds };
  yield call(fillForm, outletIds, startDate, endDate);
  yield put(grossProfitRequest(query));
}

export function* changeDatePaymentMethodsFlow(request) {
  // will be set false by paymentMethods request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  const query = { startDate, endDate: getFormattedEndDate(endDate), outletIds };
  yield call(fillForm, outletIds, startDate, endDate);
  yield put(paymentMethodsRequest(query));
}

export function* changeDateItemSalesFlow(request) {
  yield put(resetItemSales());
  // will be set false by itemSales request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds, type } = request.payload;
  const query = {
    startDate,
    endDate: getFormattedEndDate(endDate),
    outletIds,
    type,
  };
  yield call(fillForm, outletIds, startDate, endDate);
  yield put(itemSalesRequest(query));
}

export function* changeDateCategorySalesFlow(request) {
  yield put(resetCategorySales());
  // will be set false by categorySales request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  const query = { startDate, endDate: getFormattedEndDate(endDate), outletIds };
  yield call(fillForm, outletIds, startDate, endDate);
  yield put(categorySalesRequest(query));
}

export function* changeDateModifierSalesFlow(request) {
  yield put(setModifierSales([]));
  // will be set false by modifierSales request saga
  yield put(reportsShowLoadingSpinner(true));
  const { startDate, endDate, outletIds } = request.payload;
  const query = { startDate, endDate: getFormattedEndDate(endDate), outletIds };
  yield put(modifierSalesRequest(query));
}

export function* changeDateDiscountsFlow(request) {
  yield put(setDiscounts([]));
  // will be set false by discounts request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  const query = {
    startDate,
    endDate: getFormattedEndDate(endDate),
    outletIds,
  };
  yield put(discountsRequest(query));
}

export function* changeDateTaxesFlow(request) {
  yield put(setTaxes([]));
  // will be set false by taxes request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  yield put(
    taxesRequest({
      startDate,
      endDate: getFormattedEndDate(endDate),
      outletIds,
    })
  );
}

export function* changeDateGratuityFlow(request) {
  yield put(setGratuity([]));
  // will be set false by gratuities request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  yield put(
    gratuityRequest({
      startDate,
      endDate: getFormattedEndDate(endDate),
      outletIds,
    })
  );
}

export function* changeDateCollectedByFlow(request) {
  yield put(setCollectedBy([]));
  // will be set false by collectedBy request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  yield put(
    collectedByRequest({
      startDate,
      endDate: getFormattedEndDate(endDate),
      outletIds,
    })
  );
}

export function* changeDateServedByFlow(request) {
  yield put(setServedBy([]));
  // will be set false by servedBy request saga
  yield put(reportsShowLoadingSpinner(true));

  const { startDate, endDate, outletIds } = request.payload;
  yield put(
    servedByRequest({
      startDate,
      endDate: getFormattedEndDate(endDate),
      outletIds,
    })
  );
}

export function* changeOutletSalesSummaryFlow(request) {
  yield put(setSalesSummary([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);

  const salesSummaryData = yield call(
    apiReport.postSalesSummary,
    { startDate, endDate: getFormattedEndDate(endDate) },
    outletIds
  );

  const objSalesSummary = {
    discounts: salesSummaryData.discount,
    gratuity: salesSummaryData.gratuity,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    gross_sales: salesSummaryData.grossSales,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    net_sales: salesSummaryData.netSales,
    refunds: salesSummaryData.refund,
    tax: salesSummaryData.tax,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    total_collected: salesSummaryData.totalCollected,
  };
  yield put(setSalesSummary(objSalesSummary));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletSalesTypeFlow(request) {
  yield put(setSalesTypes([]));
  // set false by sales type request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);

  const { salesTypes, totalAmount } = yield call(apiReport.getSalesType, {
    startDate,
    endDate: getFormattedEndDate(endDate),
    outletIds,
  });
  yield put(setSalesTypes(salesTypes, totalAmount));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletGrossProfitFlow(request) {
  yield put(setGrossProfit([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);
  const query = { startDate, endDate: getFormattedEndDate(endDate) };
  const grossProfitData = yield call(
    apiReport.postGrossProfit,
    query,
    outletIds
  );
  yield put(setGrossProfit(grossProfitData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletPaymentMethodsFlow(request) {
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);

  const query = { startDate, endDate: getFormattedEndDate(endDate) };
  const paymentMethodsData = yield call(
    apiReport.postPaymentMethods,
    query,
    outletIds
  );

  yield put(setPaymentMethods(paymentMethodsData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletItemSalesFlow(request) {
  yield put(resetItemSales());
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const apiMap = {
    inc: postItemSales,
    qty: postItemBundleSales,
  };
  const { payload } = request;
  const { outletIds, startDate, endDate, type } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);

  const query = { startDate, endDate: getFormattedEndDate(endDate) };
  const itemSalesData = yield call(apiMap[type], query, outletIds);
  if (itemSalesData) yield put(setItemSales(itemSalesData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletCategorySalesFlow(request) {
  yield put(resetCategorySales());
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);

  const query = { startDate, endDate: getFormattedEndDate(endDate) };
  const categorySalesData = yield call(
    apiReport.postCategorySales,
    query,
    outletIds
  );
  yield put(setCategorySales(categorySalesData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletModifierSalesFlow(request) {
  yield put(setModifierSales([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);
  const {
    modifierSales,
    totalQuantity,
    totalGrossSales,
    totalDiscount,
    totalRefund,
    totalNetSales,
  } = yield call(apiReport.getModifierSales, {
    startDate,
    endDate: getFormattedEndDate(endDate),
    outletIds,
  });
  yield put(
    setModifierSales(
      modifierSales,
      totalQuantity,
      totalGrossSales,
      totalDiscount,
      totalRefund,
      totalNetSales
    )
  );
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletDiscountsFlow(request) {
  yield put(setDiscounts([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);

  const query = {
    startDate,
    endDate: getFormattedEndDate(endDate),
    outletIds,
  };
  const discountsData = yield call(apiReport.getDiscounts, query);

  yield put(setDiscounts(discountsData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletTaxesFlow(request) {
  yield put(setTaxes([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);
  const taxesData = yield call(apiReport.getTaxes, {
    startDate,
    endDate: getFormattedEndDate(endDate),
    outletIds,
  });
  yield put(setTaxes(taxesData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletGratuityFlow(request) {
  yield put(setGratuity([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { payload } = request;
  const { outletIds, startDate, endDate } = payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);
  const gratuityData = yield call(apiReport.getGratuities, {
    startDate,
    endDate: getFormattedEndDate(endDate),
    outletIds,
  });
  yield put(setGratuity(gratuityData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* changeOutletCollectedByFlow(request) {
  yield put(setCollectedBy([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  try {
    const { payload } = request;
    const { outletIds, startDate, endDate } = payload;

    setSelectedOutletIdToLocalStorage(outletIds);
    const currentOutlet = yield call(apiOutlets.outlets, {
      ids: outletIds[0],
    });
    yield put(setCurrentOutlet(currentOutlet));
    yield call(fillForm, outletIds, startDate, endDate);
    const staffData = yield call(apiReport.getStaffs, {
      startDate,
      endDate: getFormattedEndDate(endDate),
      outletIds,
    });
    yield put(setCollectedBy(staffData));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(reportsShowLoadingSpinner(false));
  }
}

export function* changeOutletServedByFlow(request) {
  yield put(setServedBy([]));
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true));

  const { outletIds, startDate, endDate } = request.payload;

  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlets.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));
  yield call(fillForm, outletIds, startDate, endDate);
  const serverData = yield call(apiReport.getServers, {
    outletIds,
    startDate,
    endDate: getFormattedEndDate(endDate),
  });
  yield put(setServedBy(serverData));
  yield put(reportsShowLoadingSpinner(false));
}

export function* exportSummaryFlow(request) {
  const { query, filename, outletIds, queryParams } = request.payload;
  try {
    yield call(
      apiReport.exportSummary,
      query,
      filename,
      outletIds,
      queryParams
    );
  } catch (error) {
    yield put(actNotif.error(getErrorMessage(error)));
  }
}

export function* exportSalesTypeFlow(request) {
  const { query } = request.payload;
  try {
    yield call(apiReport.exportSalesType, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportGrossProfitFlow(request) {
  const { query, filename, outletIds, queryParams } = request.payload;
  try {
    yield call(
      apiReport.exportGrossProfit,
      query,
      filename,
      outletIds,
      queryParams
    );
  } catch (error) {
    yield put(actNotif.error(getErrorMessage(error)));
  }
}

export function* exportHourlyItemFlow(request) {
  const { query, filename, outletIds } = request.payload;
  try {
    yield put(action.showLoadingSpinner(true));
    if (query.currentPage === 'Sold') {
      yield call(apiReport.exportHourlyItemSold, query, filename, outletIds);
    } else if (query.currentPage === 'Amount') {
      yield call(apiReport.exportHourlyItemAmount, query, filename, outletIds);
    }
    yield put(action.showLoadingSpinner(false));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportQuantitySummary(request) {
  const { query, filename, outletIds } = request.payload;
  try {
    yield put(action.showLoadingSpinner(true));
    const { data, headers } = yield call(
      exportQuantitySummaryReport,
      query,
      outletIds
    );
    const extension =
      headers['content-type'] ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ? 'xlsx'
        : 'csv';
    fileDownload(data, `${filename}.${extension}`);
  } catch (error) {
    yield put(actNotif.error(getErrorMessage(error)));
  } finally {
    yield put(action.showLoadingSpinner(false));
  }
}

export function* exportReport(request) {
  const { query, filename, outletIds, reportType, reportCategory } =
    request.payload;
  try {
    yield put(action.showLoadingSpinner(true));
    const { data, headers } = yield call(
      exportReportApi,
      query,
      outletIds,
      reportType,
      reportCategory
    );
    const extension =
      headers['content-type'] ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ? 'xlsx'
        : 'csv';
    fileDownload(data, `${filename}.${extension}`);
  } catch (error) {
    yield put(actNotif.error(getErrorMessage(error)));
  } finally {
    yield put(action.showLoadingSpinner(false));
  }
}

export function* exportPaymentMethodsFlow(request) {
  const { query, filename, outletIds, queryParams } = request.payload;
  try {
    yield call(
      apiReport.exportPaymentMethod,
      query,
      filename,
      outletIds,
      queryParams
    );
  } catch (error) {
    yield put(actNotif.error(getErrorMessage(error)));
  }
}

export function* exportItemSalesFlow(request) {
  const { query, filename, outletIds } = request.payload;
  try {
    yield call(apiReport.exportItemSales, query, filename, outletIds);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportCategorySalesFlow(request) {
  const { query, filename, outletIds } = request.payload;
  try {
    yield call(apiReport.exportCategorySales, query, filename, outletIds);
  } catch (e) {
    assertErrorHasMessage(e);
    yield put(actNotif.error(e.message));
  }
}

export function* exportModifierSalesFlow(request) {
  const { query } = request.payload;
  try {
    yield call(apiReport.exportModifierSales, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportDiscountFlow(request) {
  const { query } = request.payload;
  try {
    yield put(action.showLoadingSpinner(true));
    yield call(apiReport.exportDiscounts, query);
    yield put(action.showLoadingSpinner(false));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportTaxesFlow(request) {
  const { query } = request.payload;
  try {
    yield call(apiReport.exportTaxes, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportGratuityFlow(request) {
  const { query } = request.payload;
  try {
    yield call(apiReport.exportGratuity, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportColectedByFlow(request) {
  const { query } = request.payload;
  try {
    yield call(apiReport.exportColectedBy, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* exportServedByFlow(request) {
  const { query } = request.payload;
  try {
    yield call(apiReport.exportServedBy, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* cancelAction(cancelledTasks) {
  yield cancel(...cancelledTasks);
}

export default function* reportsSalesSaga() {
  const pageRequestTask = yield takeLatest(
    REPORTS_SALES_PAGE_REQUEST,
    reportsSalesPageRequestFlow
  );
  const getSalesSummaryTask = yield takeLatest(
    REPORTS_SALES_SUMMARY_REQUEST,
    getSalesSummaryFlow
  );
  const salesTypePageRequestTask = yield takeLatest(
    REPORTS_SALES_TYPE_PAGE_REQUEST,
    salesTypePageRequestFlow
  );
  const getSalesTypeTask = yield takeLatest(
    REPORTS_SALES_TYPE_REQUEST,
    getSalesTypesFlow
  );
  const grossProfitPageRequestTask = yield takeLatest(
    REPORTS_GROSS_PROFIT_PAGE_REQUEST,
    grossProfitPageRequestFlow
  );
  const getSalesGrossProfitTask = yield takeLatest(
    REPORTS_GROSS_PROFIT_REQUEST,
    getGrossProfitFlow
  );
  const paymentMethodsPageRequestTask = yield takeLatest(
    REPORTS_PAYMENT_METHODS_PAGE_REQUEST,
    paymentMethodsPageRequestFlow
  );
  const getPaymentMethodsTask = yield takeLatest(
    REPORTS_PAYMENT_METHODS_REQUEST,
    getPaymentMethodsFlow
  );
  const itemSalesPageReqTask = yield takeLatest(
    REPORTS_ITEM_SALES_PAGE_REQUEST,
    itemSalesPageRequestFlow
  );
  const itemSalesReqTask = yield takeLatest(
    REPORTS_ITEM_SALES_REQUEST,
    getItemSalesFlow
  );
  const categorySalesPageReqTask = yield takeLatest(
    REPORTS_CATEGORY_SALES_PAGE_REQUEST,
    categorySalesPageRequestFlow
  );
  const getCategorySalesTask = yield takeLatest(
    REPORTS_CATEGORY_SALES_REQUEST,
    getCategorySalesFlow
  );
  const brandSalesPageReqTask = yield takeLatest(
    REPORTS_BRAND_SALES_PAGE_REQUEST,
    brandSalesPageRequestFlow
  );
  const modifierSalesPageReqTask = yield takeLatest(
    REPORTS_MODIFIER_SALES_PAGE_REQUEST,
    modifierSalesPageRequestFlow
  );
  const modifierSalesReqTask = yield takeLatest(
    REPORTS_MODIFIER_SALES_REQUEST,
    getModifierSalesFlow
  );
  const discountPageReqTask = yield takeLatest(
    discountsPageRequest,
    discountsPageRequestFlow
  );
  const discountReqTask = yield takeLatest(
    REPORTS_DISCOUNTS_REQUEST,
    getDiscountsFlow
  );
  const taxPagReqTask = yield takeLatest(
    REPORTS_TAXES_PAGE_REQUEST,
    taxesPageRequestFlow
  );
  const taxReqTask = yield takeLatest(REPORTS_TAXES_REQUEST, getTaxesFlow);
  const gratuityPagReqTask = yield takeLatest(
    REPORTS_GRATUITY_PAGE_REQUEST,
    gratuityPageRequestFlow
  );
  const gratuityReqTask = yield takeLatest(
    REPORTS_GRATUITY_REQUEST,
    getGratuitiesFlow
  );
  const collectedByPageReqTask = yield takeLatest(
    REPORTS_COLLECTEDBY_PAGE_REQUEST,
    collectedByPageRequestFlow
  );
  const collectedByReqTask = yield takeLatest(
    REPORTS_COLLECTEDBY_REQUEST,
    getStaffsFlow
  );
  const servedByPageReqTask = yield takeLatest(
    REPORTS_SERVEDBY_PAGE_REQUEST,
    servedByPageRequestFlow
  );
  const servedByReqTask = yield takeLatest(
    REPORTS_SERVEDBY_REQUEST,
    getServersFlow
  );

  const changeDateSalesSummaryTask = yield takeLatest(
    REPORTS_SALES_SUMMARY_CHANGE_DATE,
    changeDateSalesSummaryFlow
  );
  const changeDateSalesTypeTask = yield takeLatest(
    REPORTS_SALES_TYPE_CHANGE_DATE,
    changeDateSalesTypeFlow
  );
  const changeDateGrossProfitTask = yield takeLatest(
    REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE,
    changeDateGrossProfitFlow
  );
  const changeDatePaymentMethodsTask = yield takeLatest(
    REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE,
    changeDatePaymentMethodsFlow
  );
  const changeDateItemSalesTask = yield takeLatest(
    REPORTS_SALES_ITEM_SALES_CHANGE_DATE,
    changeDateItemSalesFlow
  );
  const changeDateCategorySalesTask = yield takeLatest(
    REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE,
    changeDateCategorySalesFlow
  );
  const changeDateModifierSalesTask = yield takeLatest(
    REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE,
    changeDateModifierSalesFlow
  );
  const changeDateDiscountTask = yield takeLatest(
    REPORTS_SALES_DISCOUNTS_CHANGE_DATE,
    changeDateDiscountsFlow
  );
  const changeDateTaxTask = yield takeLatest(
    REPORTS_SALES_TAXES_CHANGE_DATE,
    changeDateTaxesFlow
  );
  const changeDateGratuityTask = yield takeLatest(
    REPORTS_SALES_GRATUITY_CHANGE_DATE,
    changeDateGratuityFlow
  );
  const changeDateCollectedByTask = yield takeLatest(
    REPORTS_SALES_COLLECTEDBY_CHANGE_DATE,
    changeDateCollectedByFlow
  );
  const changeDateServedByTask = yield takeLatest(
    REPORTS_SALES_SERVEDBY_CHANGE_DATE,
    changeDateServedByFlow
  );

  const changeOutletSalesSummaryTask = yield takeLatest(
    REPORTS_SALES_SUMMARY_CHANGE_OUTLET,
    changeOutletSalesSummaryFlow
  );
  const changeOutletSalesTypeTask = yield takeLatest(
    REPORTS_SALES_TYPE_CHANGE_OUTLET,
    changeOutletSalesTypeFlow
  );
  const changeOutletGrossProfitTask = yield takeLatest(
    REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET,
    changeOutletGrossProfitFlow
  );
  const changeOutletPaymentMethodsTask = yield takeLatest(
    REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET,
    changeOutletPaymentMethodsFlow
  );
  const changeOutletItemSalesTask = yield takeLatest(
    REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET,
    changeOutletItemSalesFlow
  );
  const changeOutletCategorySalesTask = yield takeLatest(
    REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET,
    changeOutletCategorySalesFlow
  );
  const changeOutletModifierSalesTask = yield takeLatest(
    REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET,
    changeOutletModifierSalesFlow
  );
  const changeOutletDiscountTask = yield takeLatest(
    REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET,
    changeOutletDiscountsFlow
  );
  const changeOutletTaxTask = yield takeLatest(
    REPORTS_SALES_TAXES_CHANGE_OUTLET,
    changeOutletTaxesFlow
  );
  const changeOutletGratuityTask = yield takeLatest(
    REPORTS_SALES_GRATUITY_CHANGE_OUTLET,
    changeOutletGratuityFlow
  );
  const changeOutletCollectedByTask = yield takeLatest(
    REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET,
    changeOutletCollectedByFlow
  );
  const changeOutletServedByTask = yield takeLatest(
    REPORTS_SALES_SERVEDBY_CHANGE_OUTLET,
    changeOutletServedByFlow
  );

  const exportSummaryTask = yield takeLatest(
    REPORTS_SALES_EXPORT_SUMMARY,
    exportSummaryFlow
  );
  const exportSalesTypeTask = yield takeLatest(
    REPORTS_SALES_EXPORT_SALES_TYPE,
    exportSalesTypeFlow
  );
  const exportGrossProfitTask = yield takeLatest(
    REPORTS_SALES_EXPORT_GROSS_PROFIT,
    exportGrossProfitFlow
  );
  const exportPaymentMethodTask = yield takeLatest(
    REPORTS_SALES_EXPORT_PAYMENT_METHODS,
    exportPaymentMethodsFlow
  );
  const exportHourlyItemTask = yield takeLatest(
    REPORTS_SALES_EXPORT_HOURLY_ITEM,
    exportHourlyItemFlow
  );
  const exportQuantitySummaryTask = yield takeLatest(
    REPORTS_SALES_QUANTITY_SUMMARY,
    exportQuantitySummary
  );
  const exportItemSalesTask = yield takeLatest(
    REPORTS_SALES_EXPORT_ITEM_SALES,
    exportItemSalesFlow
  );
  const exportCategorySalesTask = yield takeLatest(
    REPORTS_SALES_EXPORT_CATEGORY_SALES,
    exportCategorySalesFlow
  );
  const exportModifierSalesTask = yield takeLatest(
    REPORTS_SALES_EXPORT_MODIFIER_SALES,
    exportModifierSalesFlow
  );
  const exportDiscountsTask = yield takeLatest(
    REPORTS_SALES_EXPORT_DISCOUNTS,
    exportDiscountFlow
  );
  const exportTaxesTask = yield takeLatest(
    REPORTS_SALES_EXPORT_TAXES,
    exportTaxesFlow
  );
  const exportGratuityTask = yield takeLatest(
    REPORTS_SALES_EXPORT_GRATUITY,
    exportGratuityFlow
  );
  const exportCollectedByTask = yield takeLatest(
    REPORTS_SALES_EXPORT_COLECTEDBY,
    exportColectedByFlow
  );
  const exportServedByTask = yield takeLatest(
    REPORTS_SALES_EXPORT_SERVEDBY,
    exportServedByFlow
  );
  const exportReportTask = yield takeLatest(
    REPORT_SALES_GENERAL_EXPORT,
    exportReport
  );

  yield takeEvery(LOGOUT, cancelAction, [
    pageRequestTask,
    getSalesSummaryTask,

    salesTypePageRequestTask,
    getSalesTypeTask,

    grossProfitPageRequestTask,
    getSalesGrossProfitTask,

    getPaymentMethodsTask,
    paymentMethodsPageRequestTask,

    itemSalesPageReqTask,
    itemSalesReqTask,

    categorySalesPageReqTask,
    getCategorySalesTask,

    brandSalesPageReqTask,

    modifierSalesPageReqTask,
    modifierSalesReqTask,

    discountPageReqTask,
    discountReqTask,

    taxPagReqTask,
    taxReqTask,

    gratuityPagReqTask,
    gratuityReqTask,

    collectedByPageReqTask,
    collectedByReqTask,

    servedByPageReqTask,
    servedByReqTask,

    changeDateSalesSummaryTask,
    changeDateSalesTypeTask,
    changeDateGrossProfitTask,
    changeDatePaymentMethodsTask,
    changeDateItemSalesTask,
    changeDateCategorySalesTask,
    changeDateModifierSalesTask,
    changeDateDiscountTask,
    changeDateGratuityTask,
    changeDateTaxTask,
    changeDateCollectedByTask,
    changeDateServedByTask,

    changeOutletSalesSummaryTask,
    changeOutletSalesTypeTask,
    changeOutletGrossProfitTask,
    changeOutletPaymentMethodsTask,
    changeOutletItemSalesTask,
    changeOutletCategorySalesTask,
    changeOutletModifierSalesTask,
    changeOutletDiscountTask,
    changeOutletTaxTask,
    changeOutletGratuityTask,
    changeOutletCollectedByTask,
    changeOutletServedByTask,

    exportSummaryTask,
    exportSalesTypeTask,
    exportGrossProfitTask,
    exportPaymentMethodTask,
    exportHourlyItemTask,
    exportQuantitySummaryTask,
    exportItemSalesTask,
    exportCategorySalesTask,
    exportModifierSalesTask,
    exportDiscountsTask,
    exportTaxesTask,
    exportGratuityTask,
    exportCollectedByTask,
    exportServedByTask,
    exportReportTask,
  ]);
}
